import { getReturnedOrRevokedFactors } from "../../../api/requestAxios/invoice";
import constants from "../../../constants/constants";
import { CommaSeparator, ToPersianNumber } from "../../../functions";
import { ErrorToast } from "../../../shared";
import moment from 'moment';
import InvoiceTable from "../invoiceTable";
import { useEffect } from "react";
import { toast } from "react-toastify";


const GetReturnAndRevoke = ({
    setLastFactorNumber,
    setLastFactorDate,
    setMessageEmpty,
    setData,
    data,
    objGetData,
    value,
    setLoading,
    loading,
    setItemInLoading,
    itemInLoading,
    selectedStatus,
    setItemForDownload,
    setResendItemInLoading,
    isGetRetuenRevoke
}) => {

    useEffect(() => {
        getReturnRevoke()
    }, [isGetRetuenRevoke])

    const returnRevokData = (dataInvoiceReturnRevoke) => {
        setLastFactorNumber(dataInvoiceReturnRevoke?.LastInvoiceNumberInFactor);
        setLastFactorDate(dataInvoiceReturnRevoke?.LastAcceptedFactorPersianDate);
        if (dataInvoiceReturnRevoke.RevokeOrReturnOfficialFactorRespons.length === 0) {
            setMessageEmpty(constants.NoExitDataTitle)
            let temp = { ...data }
            temp.data = []
            setData(temp)
        } else {
            setMessageEmpty('')
            let arrTemp = []
            dataInvoiceReturnRevoke?.RevokeOrReturnOfficialFactorRespons?.forEach((item, index) => {
                item.row = ToPersianNumber(index + 1)
                item.InvoiceNumberInFactorFa = ToPersianNumber(item.InvoiceNumberInFactor)
                item.Status = item?.Revoked ? constants.Revoke : constants.Return
                item.StatusEn = 'ReturnRevoke'
                item.PayableAmountFa = item?.TotalAmountReservedOrReturned ? ToPersianNumber(CommaSeparator(item?.TotalAmountReservedOrReturned)) + '‌ ' + constants.Currency : '---'
                item.OfficialFactorCreatePersianDateFa = item.OfficialFactorCreatePersianDate ? item.OfficialFactorCreatePersianDate : '---'
                item.FirstNameAndLastName = item?.FirstNameAndLastName ? item?.FirstNameAndLastName : '---'
                item.CreatorNameAndFamily = item?.CreatorNameAndFamily ? item?.CreatorNameAndFamily : '---'
                item.ParentInvoiceNumberInFactor = item?.ParentInvoiceNumberInFactor
                item.ParentTaxId = item?.ParentTaxId
                item.ParentOfficialFactorCreatePersianDate = item?.ParentOfficialFactorCreatePersianDate
                item.ParentOfficialFactorDate = item?.ParentOfficialFactorDate
                item.ParentOfficialFactorId = item?.ParentOfficialFactorId
                item.ParentOfficialFactorType = item?.ParentOfficialFactorType
                item.CompanyName = item?.CompanyName
                item.idTable = index + 1
                arrTemp.push(item)
            })
            let temp = { ...data }
            temp.data = arrTemp
            setData(temp)
        }
    }
    const getReturnRevoke = async () => {
        let temp = { ...objGetData }
        temp.FromDate = moment(new Date(value[0])).local('en').format(' YYYY-MM-DD')
        temp.ToDate = moment(new Date(value[1])).local('en').format('YYYY-MM-DD')
        delete temp.OfficialFactorType

        // delete temp.FinancialPeriodId
        delete temp.FinancialPeriodId


        try {
            const dataInvoiceRturnRevoke = await getReturnedOrRevokedFactors(temp)
            setLoading(false)
            if (!dataInvoiceRturnRevoke?.data?.isSuccess) {
                toast.Erroe(dataInvoiceRturnRevoke?.data?.Description)

            } else {
                returnRevokData(dataInvoiceRturnRevoke?.data)
            }
        }
        catch {
            setLoading(false)
            ErrorToast(constants.ServerErroe)

        }

    }

    return (
        <>
            {
                data?.data?.length > 0 && <InvoiceTable
                    data={data}
                    setData={setData}
                    setItemInLoading={setItemInLoading}
                    itemInLoading={itemInLoading}
                    selectedStatus={selectedStatus}
                    setItemForDownload={setItemForDownload}
                    setResendItemInLoading={setResendItemInLoading}
                />
                // : <div className='table-context-invoice d-flex justify-content-center m-5'>
                //     <div className='table-loading-invoice'>
                //         <div className="spinner-border" role="status" aria-hidden="true"></div>
                //     </div>
                // </div>
            }
        </>

    )
}
export default GetReturnAndRevoke